/**
 * emailDeliveryCorrelationEvidenceApi
 *
 * DASH-EMAIL-011: client for the real, read-only MESSAGE-grain correlation-
 * evidence Dashboard API (`GET /api/email-delivery/dashboard/correlation-evidence`).
 *
 * Sourced from email_delivery_messages' own correlation_status field --
 * a STRICTLY EVENT-grain-free read (email_delivery_events is never queried
 * for this metric). This is a different entity population from
 * emailDeliveryRecipientDndApi.js's RECIPIENT-grain DND read and
 * emailDeliveryRecipientHealthApi.js's RECIPIENT-grain hygiene read -- this
 * module must never be used to fetch or substitute for either of those,
 * and neither of those clients must ever be used for correlation evidence.
 * See email_delivery_correlation_dashboard_service.py's own docstring for
 * the canonical-source rule this pairing enforces.
 *
 * Wraps the SAME shared `api` axios instance every other real-backed War
 * Room surface already uses -- no second HTTP stack, no collection name
 * ever appears here or in any caller. Auth (Bearer token) and account
 * scoping (X-Account-ID header) are attached automatically by that
 * instance's own request interceptor; this module never accepts or
 * forwards a caller-supplied account/tenant/location id -- this endpoint
 * takes no query parameters at all.
 *
 * Response shape: {correlated_message_count, awaiting_correlation_message_count,
 * evidence_status: "available"|"unavailable", generated_at}. Never the raw
 * message document, a recipient email, a GHL contact/message id, a
 * SendGrid message id, an SMTP message id, a location id, or a raw event
 * identity.
 */
import { api } from "./api";

export async function getEmailDeliveryCorrelationEvidence() {
  const res = await api.get("/email-delivery/dashboard/correlation-evidence");
  return res.data;
}

export default getEmailDeliveryCorrelationEvidence;
